/* eslint-disable spaced-comment */
/* eslint-disable no-plusplus */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable no-self-compare */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from "moment";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
// import { ChevronDown } from "react-feather";
import { queryDateFormat } from "../../../config/constants";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import { handleErrors } from "../../services/handleErrors";
import { fetchTaskCategories, patchTask, patchTasks } from "../../services/taskServices";
// import { taskUtil } from "../../utils/taskUtil";
import { alertUtil } from "../../utils/alertUtil";

const AlertListTable = ({ alerts, novedades, handleClickAlert, withPaging, newAlertUpdated, withClientData }) => {
  const { currentUser } = useAuth();
  const orderedAlerts = alerts && alerts.sort((a, b) => moment(a.dueDate) - moment(b.dueDate));
  const nextToCompleteIndex = orderedAlerts && orderedAlerts.findIndex((alert) => alert.completeDate === null);
  const today = moment().format(queryDateFormat);
  const [currentPage, setCurrentPage] = useState();
  const [currentSortFieldId, setCurrentSortFieldId] = useState();
  const [currentSortAsc, setCurrentSortAsc] = useState();
  const [categories] = useFetcher(fetchTaskCategories);
  const alertTypes = categories.type;

  const getNovedad = (alerta) => {
    return novedades && novedades.find((novedad) => novedad.id === alerta.novedadId);
  };
  const getAlertTypeStr = (typeId) => {
    const { text } = alertTypes.find((alert) => alert.id === typeId);
    return text;
  };

  const handleTogleCheck = async (alertId) => {
    try {
      const orderedalertsNew = [...alerts];
      const alertToUpdate = orderedalertsNew.find((el) => el.id === alertId);
      if (alertToUpdate.completeDate) {
        const { isConfirmed } = await SweetAlert.fire({
          title: `¿Esta seguro de rechazar la alerta?`,
          text: "Una vez rechazada, se le enviará una notificación al responsable",
          icon: "warning",
          confirmButtonColor: "#bf0d3e",
          showCancelButton: true,
          showConfirmButton: true,
        });
        if (isConfirmed) {
          alertToUpdate.completeDate = null;
          const { message, result } = await patchTask(alertToUpdate.novedadId, alertToUpdate);
          if (result.id) {
            newAlertUpdated(result);
            toast.success(message);
          } else {
            toast.warning(message);
          }
        }
      } else {
        alertToUpdate.completeDate = today;
        const { message, result } = await patchTask(alertToUpdate.novedadId, alertToUpdate);
        if (result.id) {
          newAlertUpdated(result);
          toast.success(message);
        } else {
          toast.warning(message);
        }
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  return (
    <div className="table-responsive support-table" style={{ marginTop: !withClientData ? "45px" : "" }}>
      {withPaging ? (
        <DataTable
          title={withClientData ? "Alertas" : null}
          paginationComponentOptions={{ rowsPerPageText: "Tareas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todas" }}
          paginationDefaultPage={currentPage}
          onChangePage={(page) => setCurrentPage(page)}
          defaultSortFieldId={currentSortFieldId}
          defaultSortAsc={currentSortAsc === "asc"}
          onSort={(column, direction) => {
            setCurrentSortFieldId(column.id);
            setCurrentSortAsc(direction);
          }}
          noDataComponent={
            <div className="p-3">
              <b>No se encontraron alertas</b>
            </div>
          }
          striped
          pagination
          data={alerts}
          columns={
            !withClientData
              ? [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (alerta) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickAlert(alerta)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                  },
                  {
                    name: "Tipo",
                    selector: (alerta) => alertTypes && getAlertTypeStr(alerta.type),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Concepto",
                    // eslint-disable-next-line radix
                    selector: (alerta) => alerta.concepto && alerta.concepto.text,
                    sortable: true,
                    center: true,
                    id: "concepto",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Observador",
                    selector: (alerta) => {
                      return alerta.observador && alerta.observador.nombreApellido;
                    },
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "observador",
                  },
                  {
                    name: "Responsable",
                    selector: (alerta) => alerta.responsable && alerta.responsable.nombreApellido,
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "responsable",
                  },

                  {
                    name: "Vencimiento",
                    cell: (alerta) => moment(alerta.dueDate).format(queryDateFormat),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (alerta) => (alerta.completeDate ? moment(alerta.completeDate).format(queryDateFormat) : "-"),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (alerta) => alertUtil(alerta).statusHtml(),
                    sortFunction: (alerta) => alertUtil(alerta).statusStr(),
                    sortable: true,
                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    cell: (alerta) => (
                      <span className="task-action-btn">{alertUtil(alerta).statusCheck(handleTogleCheck, currentUser, orderedAlerts, 0, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
              : [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (alerta) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickAlert(alerta)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                  },
                  {
                    name: "Subcliente",
                    // eslint-disable-next-line radix
                    selector: (alerta) => (getNovedad(alerta) && getNovedad(alerta).cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0)) || "-",
                    sortable: true,
                    center: true,
                    id: "subcliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Cliente",
                    selector: (alerta) => getNovedad(alerta) && getNovedad(alerta).cliente.razonSocial,
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "cliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Sucursal",
                    selector: (alerta) => getNovedad(alerta) && getNovedad(alerta).sucursal.titulo,
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "sucursal",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Tipo",
                    selector: (alerta) => alertTypes && getAlertTypeStr(alerta.type),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Concepto",
                    // eslint-disable-next-line radix
                    selector: (alerta) => alerta.concepto && alerta.concepto.text,
                    sortable: true,
                    center: true,
                    id: "concepto",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Responsable",
                    selector: (alerta) => alerta.responsable && alerta.responsable.nombreApellido,
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "responsable",
                  },
                  {
                    name: "Observador",
                    selector: (alerta) => alerta.observador && alerta.observador.nombreApellido,
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "observador",
                  },
                  {
                    name: "Vencimiento",
                    cell: (alerta) => moment(alerta.dueDate).format(queryDateFormat),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (alerta) => (alerta.completeDate ? moment(alerta.completeDate).format(queryDateFormat) : "-"),
                    sortable: true,
                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (alerta) => alertUtil(alerta).statusHtml(),
                    sortFunction: (alerta) => alertUtil(alerta).statusStr(),
                    sortable: true,
                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    cell: (alerta) => (
                      <span className="task-action-btn">{alertUtil(alerta).statusCheck(handleTogleCheck, currentUser, orderedAlerts, 0, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
          }
        />
      ) : (
        <table className="table text-center">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Tipo</th>
              <th scope="col">Concepto</th>
              <th scope="col">Vencimiento</th>
              <th scope="col">Resolución</th>
              <th scope="col">Responsable</th>
              <th scope="col">Observador</th>
              <th scope="col">Estado</th>
              <th scope="col" aria-label="Select">
                {" "}
              </th>
            </tr>
          </thead>
          <tbody>
            {orderedAlerts &&
              orderedAlerts.map((alerta, currentIndex) => (
                <tr key={alerta.id} className="task task-container">
                  <td>
                    <button className="btn btn-link" type="button" onClick={() => handleClickAlert(alerta)}>
                      Ver
                    </button>
                  </td>
                  <td>{alertTypes && getAlertTypeStr(alerta.type)}</td>
                  <td>{alerta.concepto && alerta.concepto.text}</td>
                  <td>{alerta.completeDate ? moment(alerta.completeDate).format(queryDateFormat) : "-"}</td>
                  <td>{moment(alerta.dueDate).format(queryDateFormat)}</td>
                  <td>{alerta.responsable && alerta.responsable.nombreApellido}</td>
                  <td>{alerta.observador && alerta.observador.nombreApellido}</td>
                  <td>{alertUtil(alerta).statusHtml()}</td>
                  <td>
                    <span className="task-action-btn">
                      {alertUtil(alerta).statusCheck(handleTogleCheck, currentUser, orderedAlerts, currentIndex, nextToCompleteIndex)}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AlertListTable;
